<template>
  <!-- 左侧公共 -->
  <!-- <div id="fixedHeaderRoot" class="pubLeft isFixed" > -->
	  <div id="pubLeft" class="pubLeft" >
		<!--信息公告 -->
		<!-- <div class="body_content_meeting_right_cont">
			<div class="body_content_meeting_right_clurmb">
				<i class="icladifo">信息公告</i>
				<span>更多<i class="iconfont icon-youjiantou"></i></span>
			</div>
			<div class="body_content_meeting_right_list">
				<ul>
					<li v-for="(item,index) in accodrdingListA" :key="index">
						<router-link :to="{name:'hotpushdetail',query:{ContentID:item.ContentID,title:'信息公告'}}">
							<i class="iconfont icon-fangkuai"></i>
							<span v-html="item.Title" style="top:12px;"></span>
						</router-link>
					</li>
				</ul>
			</div>
		</div>	 -->
  </div>
</template>

<script>
import router from '@/router/index'
import $ from 'jquery'
import Swiper from 'swiper'
import axios from 'axios'
import { mixin } from "../../../assets/script/scrollnav";
import { pagination } from '../../../../src/assets/mixin/data-table'

export default {
  name:'pubLeft',
  mixins: [pagination],
  data(){
    return{
			// 编辑部公告
      Info:[],
			// 期刊检索 年、期、栏目
      bankList:[],
      periodBB:[],
      column:[
        {
          value:'选项一',
          label:'社会学笔谈'
        },
        {
          value:'选项二',
          label:'马克思主义社会学专栏'
        },
        {
          value:'选项三',
          label:'专题研究'
        }
      ],
      value:'',
      valueB:'',
      valueC:'',
      title:'',
      urname:'',
			keyword:'',
			headerFixed:false,
			// 信息列表
			accodrdingListA:[],
			// 下载排行
			accodrdingListB:[],
			// 阅读排行
			accodrdingListC:[],
      accodrdingList:[
        {title:'又有作者险受骗！论文投稿谨'},
        {title:'2019年春节放假通知宣传册'},
        {title:'2019，愿与您携手依旧 现代'},
        {title:'2018年中国科技核心期刊目录'},
        {title:'又有作者险受骗！论文投稿谨'},
        {title:'又有作者险受骗！论文投稿谨'},
        {title:'实用心脑肺血管病杂志201'}
      ],
    }
  },
  methods:{
    // 获取期刊检索栏目列表
    getJourList(){
      var params = new URLSearchParams();
      params.append('JournalID', 202208020001);
      axios.post('/IssueWebAPI/GetJournalChannelList',params).then((res) => {
        this.column = res.data.data
        this.column.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10);
        })
      })
    },
    getperord(){
      var params = new URLSearchParams();
      params.append('JournalID', 202208020001);
      axios.post('/IssueWebAPI/GetIssueSetList',params).then((res) => {
        this.bankList = res.data.data.bankList
      })
    },
    getperordBB(year){
      var params = new URLSearchParams();
      params.append('JournalID', 202208020001);
      params.append('year', year);
      axios.post('/IssueWebAPI/GetIssueSetList',params).then((res) => {
        this.periodBB =  res.data.data.bankList[0].perioid
      })
    },
    getSearchBC(item){
      this.$router.push({
        path:'/Orthop/Journal',
        query:{
          year:this.value,
          perod:this.valueB,
          column:item,
          title:this.title,
          orgName:this.urname,
          key:this.keyword
        }
      })
		},
		// 获取通知公告
		getaccodrdingListA(){
			axios.post('SiteContentAPI/GetPageList',{
				JournalID:202208020001,
				ChannelID:3060,
				PageSize:7,
				CurrentPage:1
			}).then((res) => {
				this.accodrdingListA = res.data._itemList
				this.accodrdingListA.forEach((item) => {
					item.AddDate = item.AddDate.substr(0,10);
				})
			})
		},
		// 获取下载排行
		getaccodrdingListB(){
			axios.post("/IssueWebAPI/GetIssueContentPageList", {
				JournalID:202208020001,
				PageSize:7,
				CurrentPage:1,
				SortName:'Downloads',
				SortOrder:'DESC'
			}).then((res) => {
				this.accodrdingListB = res.data.data._itemList
				this.accodrdingListB.forEach((item) => {
					item.AddDate = item.AddDate.substr(0,10);
				})
			})
		},
		// 获取阅读排行
		getaccodrdingListC(){
			axios.post("/IssueWebAPI/GetIssueContentPageList", {
				JournalID:202208020001,
				PageSize:7,
				CurrentPage:1,
				SortName:'Hits',
				SortOrder:'DESC'
			}).then((res) => {
				this.accodrdingListC = res.data.data._itemList
				this.accodrdingListC.forEach((item) => {
					item.AddDate = item.AddDate.substr(0,10);
				})
			})
		},
    windTo(url){
      window.open(url);
		},
		handleScroll(){
			// 得到页面滚动的距离
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// 判断页面滚动的距离是否大于吸顶元素的位置
			this.headerFixed = scrollTop > (this.offsetTop - this.offsetHeight * 2);
		},
    // /IssueWebAPI/GetJournalChannelList
  },
  components:{

  },
  created(){
		this.getaccodrdingListA()
		this.getaccodrdingListB()
		this.getaccodrdingListC()
    this.getJourList();
    // this.getInfo();
		this.getperord();
		let pId = this.$route.params.pId;
		if(pId){
			this.initOther(pId);
		}
			// 监听dom渲染完成
		this.$nextTick(function(){
			// 这里fixedHeaderRoot是吸顶元素的ID
			let header = document.getElementById("fixedHeaderRoot");
			// 这里要得到top的距离和元素自身的高度
			// this.offsetTop = header.offsetTop;
			// this.offsetHeight = header.offsetHeight;
			// console.log("offsetTop:" + this.offsetTop + "," + this.offsetHeight);
		});
	},
	mounted() {
		// handleScroll为页面滚动的监听回调
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed(){
		window.removeEventListener('scroll', this.handleScroll);
	},
	// watch: {
  //   //监听相同路由下参数变化的时候，从而实现异步刷新
  //   '$route'(to,from) {
  //     //做一些路由变化的响应
  //     //打开加载动画
  //     this.loading = true;
  //     //重新获取数据
  //     this.getInfo();
  //     /** 初始化其他数据 */
  //     let pid = this.$route.query.id;
  //     if(pid){
  //       this.initOther(pid);
  //     }
  //   },
  // },
  computed: {

  },
}
</script>

<style lang="less" scoped>
.pubLeft{
	width: 100%;
	height:auto;
	margin-top: 45px;
	// 信息公告
	.body_content_meeting_right_cont{
		width: 273px;
		border:1px solid #E2E2E2;
		border-top:6px solid #b80000;
		margin-top:16px;
		background: #fff;
		.body_content_meeting_right_clurmb{
			height: 55px;
			text-align: left;
			line-height: 55px;
			border-bottom: 1px solid #E2E2E2;
			letter-spacing: 3px;
			padding-left: 28px;
			.icladifo{
				font-style: italic;
				font-size:20px;
				font-weight:400;
				color: #b80000;
				font-weight: bold;
			}
			span{
				color: #393939;
				font-size: 14px;
				float: right;
				padding-right: 5px;
				cursor: pointer;
				i{
					position: relative;
    			top: 1px;
				}
			}
		}
		.body_content_meeting_right_listB{
			li{
				padding: 10px 0;
				border-bottom: 1px dashed #E2E2E2;
			}
			li:last-child{
				border: none;
			}
		}
		.body_content_meeting_right_list{
			padding: 10px 6px 6px 6px;
			ul{
				width: 100%;
				height: auto;
				li{
					width: 100%;
					margin-bottom:4px;
					text-overflow:ellipsis;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					line-clamp: 1;
					-webkit-box-orient: vertical;
					cursor: pointer;
					i{
						color: #b80000;
						font-size: 18px;
						margin-right: 1px;
					}
					span:nth-child(2){
						width: 77%;
						display: inline-block;
						font-size: 14px;
						color: #000;
						overflow: hidden;
						text-overflow: ellipsis;
						-webkit-line-clamp: 1;
						line-clamp: 1;
						white-space: nowrap;
						position: relative;
    				top: 6px;
						/deep/p{
							width: 100%;
							display: inline-block;
							overflow: hidden;
							text-overflow: ellipsis;
							-webkit-line-clamp: 1;
							line-clamp: 1;
							white-space: nowrap;
						}
					}
					span:nth-child(3){
						position: absolute;
						right: 10px;
						margin-top: 7px;
						font-size: 14px;
						color: #757575;
					}
				}
				li:hover{
					span{
						color: #b80000;
						a{
							color: #b80000;
						}
					}
				}
			}
		}
	}
}

@media screen and (max-width:1010px){
	.pubLeft{
		display: none;
	}
}
</style>i



// WEBPACK FOOTER //
// src/components/public/pubLeft/index.vue